import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import TextWithClipboard from 'app/components/UI/TextWithClipboard';

import { KybDetailsModalProps } from './types';

interface DetailRowProps {
  label: string;
  value: string;
  showClipboard?: boolean;
}

function DetailRow({ label, value, showClipboard = true }: DetailRowProps) {
  return (
    <HStack
      justify="space-between"
      align="center"
      py="16px"
      px="20px"
      borderRadius="md"
      bg="gray.50"
      w="full"
      borderBottom="1px solid"
      borderBottomColor="gray.200"
    >
      <Text fontWeight="semibold" color="gray.700">
        {label}
      </Text>
      {showClipboard ? (
        <TextWithClipboard truncate={false} value={value} />
      ) : (
        <Text color="gray.900">{value}</Text>
      )}
    </HStack>
  );
}

function KybDetailsModal({ isOpen, onClose, kyb }: KybDetailsModalProps) {
  const handleClose = () => {
    onClose();
  };

  const formatAddress = () => {
    const parts = [
      kyb.address.addressLine1,
      kyb.address.addressLine2,
      kyb.address.city,
      kyb.address.postCode,
      kyb.address.countryCode,
    ].filter(Boolean);
    return parts.join(', ');
  };

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={handleClose}
      size="2xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">Company details</Text>
          </HStack>
        </ModalHeader>
        <ModalBody>
          <VStack align="stretch" spacing="0px">
            <DetailRow label="Company Name:" value={kyb.companyName} />
            <DetailRow label="Company Number:" value={kyb.companyNumber} />
            <DetailRow
              label="Client Admin:"
              value={`${kyb.contactDetails.firstName} ${kyb.contactDetails.lastName}`}
            />
            <DetailRow label="Client Admin Email:" value={kyb.contactDetails.email} />
            <Box py="16px" px="20px" borderRadius="md" bg="gray.50" w="full">
              <Text fontWeight="semibold" color="gray.700" mb="8px">
                Company Address:
              </Text>
              <TextWithClipboard
                truncate={false}
                justifyContent="space-between"
                value={formatAddress()}
              />
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleClose} size="sm">
            Close details
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default KybDetailsModal;
